import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import React from "react";

type DiscussWrapperProps = { children: React.ReactNode };

export default function DiscussWrapper({ children }: DiscussWrapperProps) {
  return <div sx={lessonDiscussWrapperStyle}>{children}</div>;
}

const lessonDiscussWrapperStyle: ThemeUIStyleObject = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
};
